import {useSelector} from 'react-redux';
import {useGetCurrentSchoolQuery} from '../../api/services/schoolManagementService';
import {useGetGroupFiltersQuery} from '../../api/services/groupService';
import useUser from '../../utility/hooks/useUser';
import {describeSetup} from './felicitySetup';

/** AD-2653: the school's own set-up for Felicity. Staff are sent the school's settings; everyone their access. */
const useFelicitySetup = () => {
    const {user} = useUser();
    const staff = Boolean(user?.roles && user.hasElevatedAccess());
    const {permissions, parentPermissions} = useSelector((state) => state.application.authData ?? {});
    const {data: school} = useGetCurrentSchoolQuery({}, {skip: !staff});
    const {data: groups} = useGetGroupFiltersQuery({fetchOnlyVisible: false, maxLevel: 2}, {skip: !staff});

    return describeSetup({school: staff ? school : null, permissions, parentPermissions, groups: staff ? groups : null});
};

export default useFelicitySetup;
